import Timer from './_timer.js'
import FlexPane from './_flex-pane.js'

export default {
  name: 'SessionTime',
  values: {
    layoutDirection: 'vertical',
    timeFormat: 'HH:mm:ss',
    showLabel: true,
    timerHorizontal: {
      configSet: Timer,
      configValues: {
        timerWrapper: {
          style: {
            alignItems: 'center',
          },
        },
        timerFourDigits: {
          timeBox: {
            style: {
              minWidth: '50px',
            },
          },
        },
        timerFiveDigits: {
          timeBox: {
            style: {
              minWidth: '50px',
            },
          },
        },
      },
    },
    timerVertical: {
      configSet: Timer,
      configValues: {
        timerWrapper: {
          style: {
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          },
        },
        timeString: {
          style: {
            flexGrow: 0,
          },
        },
        timerFourDigits: {
          timeBox: {
            style: {
              minWidth: '50px',
            },
          },
        },
        timerFiveDigits: {
          timeBox: {
            style: {
              minWidth: '50px',
            },
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0 10px',
          flexGrow: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
